import React, { useEffect, useState } from 'react';
import {
    Page,
    Text,
    Image,
    Document,
    StyleSheet,
    View,
    Svg,
    Polygon,
    G
} from '@react-pdf/renderer';

import { cssHelper } from './CssHelper';

import Html from 'react-pdf-html';

import logo_pdf_bold from 'images/logo_pdf_bold.png';
import { set } from 'lodash';

export function encodeSvgString(svg) {
    const toNodes = (html) =>
        new DOMParser().parseFromString(html, 'text/html').body.childNodes[0];

    var decoded = new XMLSerializer().serializeToString(toNodes(svg));
    const b64String = window.btoa(decoded);
    const imgSource = `data:image/svg+xml;base64,${b64String}`;
    return imgSource;
}

export function svgToDataURI(svgData, renderWidth, renderHeight) {
    const id = '1';
    const canvas = document.createElement('canvas');
    canvas.setAttribute('id', id);
    canvas.setAttribute('style', 'display: none');
    document.body.appendChild(canvas);

    canvas.width = renderWidth;
    canvas.height = renderHeight;
    const ctx = canvas.getContext('2d');

    if (!ctx) {
        throw new Error('no canvas 2d context');
    }

    const img = document.createElement('img');
    img.setAttribute('src', encodeSvgString(svgData));

    return new Promise((res, rej) => {
        img.onload = function load() {
            ctx.drawImage(img, 0, 0);
            const url = canvas.toDataURL('image/jpeg', 1.0);
            const el = document.getElementById(id);
            if (el) el.remove();

            res(url);
        };
    });
}

const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35
    },
    title: {
        fontSize: 24,
        textAlign: 'center'
    },
    text: {
        margin: 12,
        fontSize: 14,
        textAlign: 'justify',
        fontFamily: 'Times-Roman'
    },
    logo: {
        // marginVertical: 8,
        // marginHorizontal: 10,
        width: '210px',
        height: '25px'
    },
    image: {
        // marginVertical: 15,
        // marginHorizontal: 10
        // height: '150px',
        // width: '150px'
    },
    containerTestImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '50px',
        marginRight: '15px'
    },
    testImage: {
        height: 'auto',
        width: '100%'
    },
    headerFlex: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        width: '100%'
    },
    headerTextRight: {
        margin: 12,
        marginBottom: 0,
        marginTop: 15,
        fontSize: 8,
        textAlign: 'right',
        opacity: 0.5,
        position: 'absolute',
        top: 0,
        right: 0,
        width: '150px'
    },
    header: {
        fontSize: 16,
        marginBottom: 15,
        textAlign: 'center',
        color: 'black'
    },
    analysisName: {
        color: '#407cb1',
        fontSize: '18px',
        fontWeight: 'bold',
        marginTop: '30px',
        marginBottom: '15px'
    },
    analysisChartName: {
        color: '#60091d',
        fontSize: '14px',
        marginBottom: '5px'
    },
    analysisChartNameHr: {
        height: '2px',
        borderBottom: '1px solid #60091d',
        marginBottom: '5px'
    },
    analysisChartDescription: {
        fontSize: 10,
        opacity: 0.7,
        marginBottom: '20px'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey'
    },
    footerFlex: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        position: 'absolute',
        bottom: 20,
        left: 35,
        width: '100%'
    },
    footerTextLeft: {
        margin: 12,
        fontSize: 8,
        textAlign: 'justify',
        opacity: 0.5
    },
    footerTextRight: {
        margin: 12,
        fontSize: 8,
        textAlign: 'justify',
        opacity: 0.5
    },

    statisticsBox: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        marginTop: '15px'
    },

    statisticsCard: {
        border: '1px solid #407cb1',
        display: 'flex',
        flexDirection: 'column',
        minWidth: '120px',
        flexWrap: 'no-wrap',
        margin: 5
    },

    statisticsTitle: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        fontSize: '8px',
        color: '#407CB1',
        opacity: 0.7,
        margin: '5px 5px 0px 5px'
    },
    statisticsDescription: {
        display: 'flex',
        textAlign: 'center',
        flexWrap: 'wrap',
        fontSize: '8px',
        color: '#407CB1',
        margin: '10px'
    }
});

const PDFFile = (props) => {
    let autoregression = '';
    let autoregressionStdRes = '';
    let boxplot = '';
    let confidenceIntervals = '';
    let dotplot = '';
    let histogram = '';
    let timeplot = '';
    let autoregressionMulti = '';
    let regressionMulti = '';
    let regressionStdResMulti = '';
    let scatterplotMulti = '';
    let qqPlotImages = { normal: '', lognormal: '', burr12: '' };

    // if (props.autoregressionMultiPDF !== 'empty') {
    //     autoregressionMulti = svgToDataURI(
    //         props.autoregressionMultiPDF,
    //         2400,
    //         1600
    //     );
    // }

    // if (props.regressionMultiPDF !== 'empty') {
    //     regressionMulti = svgToDataURI(props.regressionMultiPDF, 2400, 1600);
    //     scatterRegressionMulti = svgToDataURI(
    //         props.scatterRegresionMultiPDF,
    //         2400,
    //         1600
    //     );
    // }

    // if (props.scatterplotMultiPDF !== 'empty') {
    //     scatterplotMulti = svgToDataURI(props.scatterplotMultiPDF, 2400, 1600);
    // }

    if (props.autoregPDF !== 'empty') {
        autoregression = svgToDataURI(props.autoregPDF, 2400, 1600);
        autoregressionStdRes = svgToDataURI(props.autoregStdResPDF, 2400, 1600);
    }

    if (props.boxplotPDF !== 'empty') {
        boxplot = svgToDataURI(props.boxplotPDF, 2400, 1600);
    }
    if (props.confidenceIntervalsPDF !== 'empty') {
        confidenceIntervals = svgToDataURI(
            props.confidenceIntervalsPDF,
            2400,
            1120
        );
    }
    if (props.dotplotPDF !== 'empty') {
        dotplot = svgToDataURI(props.dotplotPDF, 2400, 1600);
    }
    if (props.histogramPDF !== 'empty') {
        histogram = svgToDataURI(props.histogramPDF, 2400, 1600);
    }
    // let Statistics = svgToDataURI(props.testboxplotPDF, 2400, 1600);
    if (props.timeplotPDF !== 'empty') {
        timeplot = svgToDataURI(props.timeplotPDF, 2400, 1600);
    }
    // Process QQ plot PDFs (shared across all analysis types)
    if (props.qqPlotPDFs) {
        Object.keys(props.qqPlotPDFs).forEach(plotType => {
            if (props.qqPlotPDFs[plotType] !== 'empty') {
                qqPlotImages[plotType] = svgToDataURI(props.qqPlotPDFs[plotType], 2400, 1600);
            }
        });
    }

    if (props.autoregressionMultiPDF !== 'empty') {
        autoregressionMulti = svgToDataURI(
            props.autoregressionMultiPDF,
            2400,
            1600
        );
    }
    if (props.regressionMultiPDF !== 'empty') {
        regressionMulti = svgToDataURI(props.regressionMultiPDF, 2400, 1600);
    }
    if (props.regressionStdResMultiPDF !== 'empty') {
        regressionStdResMulti = svgToDataURI(
            props.regressionStdResMultiPDF,
            2400,
            1600
        );
    }
    if (props.scatterplotMultiPDF !== 'empty') {
        scatterplotMulti = svgToDataURI(props.scatterplotMultiPDF, 2400, 1600);
    }

    // const ConfidenceIntervalsTables = `${cssHelper} ${props.strStatConfidenceIntervalsTable} ${props.strStatConfidenceIntervalsTable2}`;
    // const statisticsTables = `${cssHelper} ${props.strStatisticsOptions}`;
    // const autoregresionTables = `${cssHelper} ${props.strStatAutoregTable2} ${props.strAutoregStdResidRowsTable} ${props.strAutoregStdErrTable} ${props.strAutoregNwStdErrTable} `;
    // const regresionTables = `${cssHelper} ${props.strStatRegressionTable} ${props.strRegressionStdResidRowsTable} ${props.strRegressionStdErrTable} ${props.strRegressionNwStdErrTable}`;
    // const scatterplotTables = `${cssHelper} ${props.strStatScattTable} ${props.strScattStdResidRowsTable} ${props.strScattStdErrTable} ${props.strScatterNwStdErrTable}`;

    const autoregresionTables = `${cssHelper} ${props.strAutoregressionStatistics}`;
    const confidenceIntervalsTables = `${cssHelper} ${props.strConfidenceIntervalsStatistics}`;
    const statisticsTables = `${cssHelper} ${props.strGeneralStatistics}`;
    const statisicsRobust = `${cssHelper} ${props.strRobustStatistics}`;

    // Helper function to render QQ plots
    const renderQQPlots = (displayName) => {
        if (!qqPlotImages || (!qqPlotImages.normal && !qqPlotImages.lognormal && !qqPlotImages.burr12)) {
            return null;
        }

        return (
            <>
                {qqPlotImages.normal ? (
                    <Page style={styles.body} wrap>
                        {pageHeader}
                        <div style={styles.onePageContainer}>
                            <div style={styles.analysisChartName}>
                                <Text>{displayName}: Normal Q-Q Plot</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />
                            <div style={styles.containerTestImage}>
                                <Image style={styles.testImage} src={qqPlotImages.normal} />
                            </div>
                        </div>
                        {pageFooter}
                    </Page>
                ) : null}
                {qqPlotImages.lognormal ? (
                    <Page style={styles.body} wrap>
                        {pageHeader}
                        <div style={styles.onePageContainer}>
                            <div style={styles.analysisChartName}>
                                <Text>{displayName}: Lognormal Q-Q Plot</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />
                            <div style={styles.containerTestImage}>
                                <Image style={styles.testImage} src={qqPlotImages.lognormal} />
                            </div>
                        </div>
                        {pageFooter}
                    </Page>
                ) : null}
                {qqPlotImages.burr12 ? (
                    <Page style={styles.body} wrap>
                        {pageHeader}
                        <div style={styles.onePageContainer}>
                            <div style={styles.analysisChartName}>
                                <Text>{displayName}: Burr12 Q-Q Plot</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />
                            <div style={styles.containerTestImage}>
                                <Image style={styles.testImage} src={qqPlotImages.burr12} />
                            </div>
                        </div>
                        {pageFooter}
                    </Page>
                ) : null}
            </>
        );
    };

    const pageHeader = (
        <>
            <div style={styles.headerFlex} fixed>
                <div>
                    <Image style={styles.logo} src={logo_pdf_bold} />
                </div>
                <div style={styles.headerTextRight}>
                    <div></div>
                    <Text>Report Date: {props.currentDate}</Text>
                    {/* <Text>Time: {props.currentTime} Eastern Time</Text> */}
                </div>
            </div>

            <div style={styles.analysisName} fixed>
                <Text>Analysis name: {props.analysisDataName}</Text>
            </div>
        </>
    );

    const pageFooter = (
        <>
            <div style={styles.footerFlex} fixed>
                <div>
                    <Text style={styles.footerTextLeft}>
                        Copyright 2022 Econometrica<sup>©</sup>. All rights
                        reserved
                    </Text>
                </div>
                <div>
                    <Text
                        style={styles.footerTextRight}
                        render={({ pageNumber, totalPages }) =>
                            `Page ${pageNumber} of ${totalPages}`
                        }
                    ></Text>
                </div>
            </div>
        </>
    );

    // let autoStdResidHeader = props.autoregStdResidHeaders.map((item) => {
    //     return (
    //         <div style={styles.tableHeaderText}>
    //             <Text>{item}</Text>
    //         </div>
    //     );
    // });

    return (
        <>
            <Document>
                {/* <Page style={styles.body}>
                    {' '}
                    <Html>{testStattt}</Html>
                </Page> */}

                {autoregression !== '' ? (
                    <>
                        <Page style={styles.body}>
                            {pageHeader}
                            {/* Autoregression Start */}
                            <div style={styles.analysisChartName}>
                                <Text>Autoregression</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />

                            {/* <div style={styles.analysisChartDescription}>
                                <Text>
                                    This is where we enter the algorythmn used
                                    to calculate the graph. It will not be too
                                    wide so we retain readibility and I’m not
                                    sure how long it needs to be
                                </Text>
                            </div> */}

                            <div style={styles.containerTestImage}>
                                <Image
                                    style={styles.testImage}
                                    src={autoregression}
                                />
                            </div>
                            {pageFooter}
                            {/* Autoregression End */}
                        </Page>
                        <Page style={styles.body}>
                            {pageHeader}

                            {/* Autoregression Start */}
                            <div style={styles.analysisChartName}>
                                <Text>Autoregression</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />

                            {/* <div style={styles.analysisChartDescription}>
                                <Text>
                                    This is where we enter the algorythmn used
                                    to calculate the graph. It will not be too
                                    wide so we retain readibility and I’m not
                                    sure how long it needs to be
                                </Text>
                            </div> */}

                            <div style={styles.containerTestImage}>
                                <Image
                                    style={styles.testImage}
                                    src={autoregressionStdRes}
                                />
                            </div>
                            {pageFooter}
                            {/* Autoregression End */}
                        </Page>
                        <Page style={styles.body}>
                            {pageHeader}

                            {/* Autoregression Start */}
                            <div style={styles.analysisChartName}>
                                <Text>Autoregression Statistics:</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />

                            <Html>{autoregresionTables}</Html>
                            {pageFooter}
                            {/* Autoregression End */}
                        </Page>
                    </>
                ) : null}

                {boxplot !== '' ? (
                    <Page style={styles.body} wrap>
                        {pageHeader}
                        <div style={styles.onePageContainer}>
                            <div style={styles.analysisChartName}>
                                <Text>Boxplot</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />

                            {/* <div style={styles.analysisChartDescription}>
                                <Text>
                                    This is where we enter the algorythmn used
                                    to calculate the graph. It will not be too
                                    wide so we retain readibility and I’m not
                                    sure how long it needs to be
                                </Text>
                            </div> */}

                            <div style={styles.containerTestImage}>
                                <Image style={styles.testImage} src={boxplot} />
                            </div>
                        </div>

                        {/* Boxplot End */}
                        {pageFooter}
                    </Page>
                ) : null}

                {confidenceIntervals !== '' ? (
                    <>
                        <Page style={styles.body} wrap>
                            {pageHeader}
                            {/* Confidence Intervals Start */}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>Confidence Intervals</Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />

                                {/* <div style={styles.analysisChartDescription}>
                                    <Text>
                                        This is where we enter the algorythmn
                                        used to calculate the graph. It will not
                                        be too wide so we retain readibility and
                                        I’m not sure how long it needs to be
                                    </Text>
                                </div> */}

                                <div style={styles.containerTestImage}>
                                    <Image
                                        style={styles.testImage}
                                        src={confidenceIntervals}
                                    />
                                </div>
                            </div>
                            {/* Confidence Intervals End */}
                            {pageFooter}
                        </Page>
                        <Page style={styles.body} wrap>
                            {pageHeader}
                            {/* Confidence Intervals Start */}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>
                                        Confidence Intervals Statistics:
                                    </Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />
                                <Html>{confidenceIntervalsTables}</Html>
                            </div>

                            {pageFooter}
                        </Page>
                    </>
                ) : null}

                {dotplot !== '' ? (
                    <Page style={styles.body} wrap>
                        {pageHeader}
                        {/* Dotplot Start */}
                        <div style={styles.onePageContainer}>
                            <div style={styles.analysisChartName}>
                                <Text>Dotplot</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />

                            {/* <div style={styles.analysisChartDescription}>
                                <Text>
                                    This is where we enter the algorythmn used
                                    to calculate the graph. It will not be too
                                    wide so we retain readibility and I’m not
                                    sure how long it needs to be
                                </Text>
                            </div> */}

                            <div style={styles.containerTestImage}>
                                <Image style={styles.testImage} src={dotplot} />
                            </div>
                        </div>
                        {/* Dotplot End */}
                        {pageFooter}
                    </Page>
                ) : null}

                {histogram !== '' ? (
                    <Page style={styles.body} wrap>
                        {pageHeader}
                        {/* Histogram Start */}
                        <div style={styles.onePageContainer}>
                            <div style={styles.analysisChartName}>
                                <Text>Histogram</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />

                            {/* <div style={styles.analysisChartDescription}>
                                <Text>
                                    This is where we enter the algorythmn used
                                    to calculate the graph. It will not be too
                                    wide so we retain readibility and I’m not
                                    sure how long it needs to be
                                </Text>
                            </div> */}

                            <div style={styles.containerTestImage}>
                                <Image
                                    style={styles.testImage}
                                    src={histogram}
                                />
                            </div>
                        </div>
                        {/* Histogram End */}
                        {pageFooter}
                    </Page>
                ) : null}


                {props.strGeneralStatistics !== '' ? (
                    <Page style={styles.body} wrap>
                        {pageHeader}
                        <div style={styles.analysisChartName}>
                            <Text style={{ marginBottom: 5 }}>Statistics:</Text>
                        </div>
                        <hr style={styles.analysisChartNameHr} />
                        {/* <Html>{statisticsTables}</Html> */}
                        <Html>{statisticsTables}</Html>
                        {pageFooter}
                    </Page>
                ) : null}

                {props.strRobustStatistics !== '' ? (
                    <Page style={styles.body} wrap>
                        {pageHeader}
                        <div style={styles.analysisChartName}>
                            <Text style={{ marginBottom: 5 }}>Statistics Robust:</Text>
                        </div>
                        <hr style={styles.analysisChartNameHr} />
                        {/* <Html>{statisticsTables}</Html> */}
                        <Html>{statisicsRobust}</Html>
                        {pageFooter}
                    </Page>
                ) : null}


                {timeplot !== '' ? (
                    <Page style={styles.body} wrap>
                        {/* Timeplot Start */}
                        {pageHeader}
                        <div style={styles.onePageContainer}>
                            <div style={styles.analysisChartName}>
                                <Text>Timeplot</Text>
                            </div>
                            <hr style={styles.analysisChartNameHr} />

                            {/* <div style={styles.analysisChartDescription}>
                                <Text>
                                    This is where we enter the algorythmn used
                                    to calculate the graph. It will not be too
                                    wide so we retain readibility and I’m not
                                    sure how long it needs to be
                                </Text>
                            </div> */}

                            <div style={styles.containerTestImage}>
                                <Image
                                    style={styles.testImage}
                                    src={timeplot}
                                />
                            </div>
                        </div>

                        {pageFooter}
                        {/* Timeplot End */}
                    </Page>
                ) : null}


                {/* Univariate QQ Plots (render when only QQ plots are selected) */}
                {(qqPlotImages && (qqPlotImages.normal || qqPlotImages.lognormal || qqPlotImages.burr12))
                 && !(autoregressionMulti !== '' || regressionMulti !== '' || regressionStdResMulti !== '' || scatterplotMulti !== '')
                 ? (
                    renderQQPlots(props.analysisDataName)
                ) : null}

                {autoregressionMulti !== '' ? (
                    <>
                        <Page style={styles.body} wrap>
                            {/* Timeplot Start */}
                            {pageHeader}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>AutoregressionX</Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />

                                {/* <div style={styles.analysisChartDescription}>
                                    <Text>
                                        This is where we enter the algorythmn
                                        used to calculate the graph. It will not
                                        be too wide so we retain readibility and
                                        I’m not sure how long it needs to be
                                    </Text>
                                </div> */}

                                <div style={styles.containerTestImage}>
                                    <Image
                                        style={styles.testImage}
                                        src={autoregressionMulti}
                                    />
                                </div>
                            </div>

                            {pageFooter}
                            {/* Timeplot End */}
                        </Page>

                        <Page style={styles.body} wrap>
                            {pageHeader}
                            {/* Confidence Intervals Start */}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>AutoregressionX Statistics:</Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />
                                <Html>{autoregresionTables}</Html>
                            </div>

                            {pageFooter}
                        </Page>
                    </>
                ) : null}
                {regressionMulti !== '' ? (
                    <>
                        <Page style={styles.body} wrap>
                            {/* Timeplot Start */}
                            {pageHeader}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>Regression</Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />

                                {/* <div style={styles.analysisChartDescription}>
                                    <Text>
                                        This is where we enter the algorythmn
                                        used to calculate the graph. It will not
                                        be too wide so we retain readibility and
                                        I’m not sure how long it needs to be
                                    </Text>
                                </div> */}

                                <div style={styles.containerTestImage}>
                                    <Image
                                        style={styles.testImage}
                                        src={regressionMulti}
                                    />
                                </div>
                            </div>

                            {pageFooter}
                            {/* Timeplot End */}
                        </Page>
                        <Page style={styles.body} wrap>
                            {/* Timeplot Start */}
                            {pageHeader}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>Regression</Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />

                                {/* <div style={styles.analysisChartDescription}>
                                    <Text>
                                        This is where we enter the algorythmn
                                        used to calculate the graph. It will not
                                        be too wide so we retain readibility and
                                        I’m not sure how long it needs to be
                                    </Text>
                                </div> */}

                                <div style={styles.containerTestImage}>
                                    <Image
                                        style={styles.testImage}
                                        src={regressionStdResMulti}
                                    />
                                </div>
                            </div>

                            {pageFooter}
                            {/* Timeplot End */}
                        </Page>
                        {renderQQPlots('Regression')}
                        {/* {renderQQPlots('Robust Regression')} */}

                        <Page style={styles.body} wrap>
                            {pageHeader}
                            {/* Confidence Intervals Start */}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>Regression Statistics:</Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />
                                <Html>{autoregresionTables}</Html>
                            </div>

                            {pageFooter}
                        </Page>
                        
                        
                    </>
                ) : null}
                {scatterplotMulti !== '' ? (
                    <>
                        <Page style={styles.body} wrap>
                            {/* Timeplot Start */}
                            {pageHeader}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>Scatterplot</Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />

                                {/* <div style={styles.analysisChartDescription}>
                                    <Text>
                                        This is where we enter the algorythmn
                                        used to calculate the graph. It will not
                                        be too wide so we retain readibility and
                                        I’m not sure how long it needs to be
                                    </Text>
                                </div> */}

                                <div style={styles.containerTestImage}>
                                    <Image
                                        style={styles.testImage}
                                        src={scatterplotMulti}
                                    />
                                </div>
                            </div>

                            {pageFooter}
                            {/* Timeplot End */}
                        </Page>

                        {renderQQPlots('Scatterplot')}

                        <Page style={styles.body} wrap>
                            {pageHeader}
                            {/* Confidence Intervals Start */}
                            <div style={styles.onePageContainer}>
                                <div style={styles.analysisChartName}>
                                    <Text>Scatterplot Statistics:</Text>
                                </div>
                                <hr style={styles.analysisChartNameHr} />
                                <Html>{autoregresionTables}</Html>
                            </div>

                            {pageFooter}
                        </Page>
                        
                    </>
                ) : null}
            </Document>
        </>
    );
};

export default PDFFile;
